import type { StoreDetails } from '@/entities/store/model'
import { withTutorialFallback } from '@/features/onboarding/lib'
import { apiFetch } from '@/shared/api'

/**
 * Fetches store details associated with the current authenticated session.
 * If tutorial mode is active, returns mock data instead of making API call.
 */
export async function fetchStoreDetails(): Promise<StoreDetails> {
  return await withTutorialFallback<StoreDetails>(
    'storeDetails',
    () => apiFetch<StoreDetails>('/me'),
  )
}
